import { jsx, jsxs } from 'react/jsx-runtime';

const Address = ({ streetAddress, streetAddress2, city, state, postalCode, country, className = '', }) => {
    return (jsx("address", { className: `not-italic ${className}`, children: jsxs("div", { className: "space-y-0.5 text-sm", children: [jsx("div", { children: streetAddress }), streetAddress2 && jsx("div", { children: streetAddress2 }), jsxs("div", { children: [city, ", ", state, " ", postalCode] }), jsx("div", { children: country })] }) }));
};

export { Address };
//# sourceMappingURL=Address.js.map
